import isServerSide from '../is-server-side'

const setBackendUserState = () => {
  if (!isServerSide() && typeof window.lightUpdateUserLoginState != 'undefined') {
    window.lightUpdateUserLoginState()
  }
}

export default setBackendUserState
